import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { PageNotFoundComponent } from "./page-not-found/page-not-found.component";
import { ContributionComponent } from "./contribution/contribution.component";
import { AddCrowdsaleComponent } from "./add-crowdsale/add-crowdsale.component";
import { SingleArticleComponent } from "./blog/single-article/single-article.component";

export const routes: Routes = [
    {
        path: "news",
        loadChildren: () =>
            import("./news/news.module").then((m) => m.NewsModule),
    },
    {
        path: "contact",
        loadChildren: () =>
            import("./contact/contact.module").then((m) => m.ContactModule),
    },
    {
        path: "about",
        loadChildren: () =>
            import("./about/about.module").then((m) => m.AboutModule),
    },
    {
        path: ":contractAddress/blog",
        loadChildren: () =>
            import("./blog/blog.module").then((m) => m.BlogModule),
    },

    {
        path: "contribution",
        loadChildren: () =>
            import("./contribution/contribution.module").then(
                (m) => m.ContributionModule
            ),
    },
    {
        path: "terms",
        loadChildren: () =>
            import("./terms/terms.module").then((m) => m.TermsModule),
    },
    {
        path: "faq",
        loadChildren: () => import("./faq/faq.module").then((m) => m.FaqModule),
    },
    {
        path: "token-release",
        loadChildren: () =>
            import("./token-release/token-release.module").then(
                (m) => m.TokenReleaseModule
            ),
    },
    {
        path: "collection",
        loadChildren: () =>
            import("./collections/collections.module").then(
                (m) => m.CollectionsModule
            ),
    },
    {
        path: "demo-application",
        loadChildren: () =>
            import("./demo-apply/demo-apply.module").then(
                (m) => m.DemoApplyModule
            ),
    },
    {
        path: ":contractAddress/info",
        loadChildren: () =>
            import("./info/info.module").then((m) => m.InfoModule),
    },
    {
        path: ":contractAddress",
        loadChildren: () =>
            import("./token-sale-lp/token-sale-lp.module").then(
                (m) => m.TokenSaleLpModule
            ),
        pathMatch: "full",
    },
    {
        path: "**",
        component: PageNotFoundComponent,
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
